import React from "react";
import styled from "styled-components";
import sowon from "../Asset/Icons/sowon.png";
import bogus from "../Asset/Icons/bogus.png";

const Box = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1000;
`;

const Anchor = styled.a`
  position: absolute;
  bottom: -10px;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  left: ${(props) => (props.who === "sowon" ? "-20px" : "default")};
  right: ${(props) => (props.who === "bogus" ? "-20px" : "default")};
  &:hover {
    transform: scale(1.1);
  }
  @media screen and (max-width: 768px) {
    left: ${(props) => (props.who === "sowon" ? "0px" : "default")};
    right: ${(props) => (props.who === "bogus" ? "0px" : "default")};
  }
`;

const Character = styled.img`
  width: 300px;
  @media screen and (max-width: 768px) {
    width: 160px;
  }
`;

const Background = () => {
  return (
    <Box>
      <Anchor
        who="sowon"
        href="https://blog.naver.com/angieswlee"
        target="_blank"
      >
        <Character src={sowon}></Character>
      </Anchor>
      <Anchor who="bogus" href="https://junwoolee.me" target="_blank">
        <Character src={bogus}></Character>
      </Anchor>
    </Box>
  );
};

export default Background;
